
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { QuickOrderPositionDto } from "@/dtos/quickOrderPositionDto";
import rules from "@/store/rules";
import { CustomerOrderDto } from "@/dtos/customerOrderDto";

@Component
export default class CreatePrepayInvoiceDialog extends Vue {
	@Prop()
	private orderId!: number;
	private order: CustomerOrderDto | null = null;
	private open: boolean = true;
	private loading: boolean = false;
	private amount: number = 0;

	private mounted() {
		this.loadOrder();
	}

	private async loadOrder() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`CustomerOrder/GetCompleteCustomerOrderById?customerOrderId=${this.orderId}`
			);
			this.order = response.data;
		} catch {
			console.error("Load order failed.");
		} finally {
			this.loading = false;
		}
	}

	private async createPrepayInvoice() {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`Invoice/createPrepayInvoice?orderId=${this.orderId}&amount=${this.amount}`
			);
			this.$store.commit("setSnackbarText", `Vorausrechnung wurde erfolgreich erstellt.`);
			this.$emit("cancel", true);
		} catch {
			this.$store.commit("setSnackbarErrorText", `Fehler beim Erstellen der Vorausrechnung`);
		} finally {
			this.loading = false;
		}
	}

	private get totalBetragOrder() {
		let total = 0;
		if (!this.order) return total;

		for (const part of this.order.parts) {
			total += part.customerPricePerPart * part.menge;
		}
		for (const position of this.order.positions) {
			total += position.customerPricePerPart * position.menge;
		}
		return total;
	}
}
